<app-bread-crumbs [breadcrumbs]="breadcrumbs"></app-bread-crumbs>
<div class="container">
  <div class="row">
    <div class="col-md-12 px-3">
      <h1><app-header-icon iconName="slideshow"></app-header-icon> {{'SLIDESHOWS' | translate}}</h1>
      <app-slideshows-overview></app-slideshows-overview>
    </div>
  </div>
</div>
